import React, { useCallback, useEffect, useRef, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import "./OtpEntry.scss";
import AlertRhombus from "../../../assets/icons/alert-rhombus.svg";
import otpVerificationImage from "../../../assets/icons/otp-verification.svg";
import { useNavigate } from "react-router-dom";
import {
  useLazyGenerateOtpQuery,
  useLazyMPinExistQuery,
  useLazyValidateOtpQuery,
} from "../Login_Api";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../redux-store/CustomReduxHooks";
import { setError } from "../../../redux-store/reducers/CsErrorSlice";
import { updateLoginData, updateScreenTag } from "../Login_Slice";
import { updateLoadingState } from "../../Feature_Loading/Loading_Slice";
import CsLocalStorageUtils from "../../../utils/CsLocalStorageUtils";
import CustomPopup from "../../../components/CustomPopup/CustomPopup";
import { Colors } from "../../../styles/constant";
import CommonGifAnimation from "../../../components/CustomGifAnimation/CommonGifAnimation";
import {
  E_ChannelOptions,
  LoginScreenValues,
  T_AnimationData,
  T_ApiResponse,
} from "../../../globalTypes/GlobalTypes";
import ExclamationMarkGif from "../../../assets/gif/Exclamation_Mark.json";
import {
  ABCD_APPSTORE_URL,
  ABCD_PLAYSTORE_URL,
  functionalityCodeForGenerateOtpApi,
  GTAScreenType,
  onUserLoginCleverTapStatic,
  otpScreenErrorMsg,
  SCREEN_TYPE,
} from "../../../utils/constants";
import CsSessionStorageUtils from "../../../utils/CsSessionStorageUtils";
import { T_GenerateOtpPay, T_ValidateOtpRes } from "../Login_Types";
import {
  defaultEmptyFun,
  getMobileOperatingSystem,
  getValidEmailFromCustomerAndLobDetails,
  windowOpen,
} from "../../../utils/helper";
import { CleverTapEventType } from "../../../utils/CleverTapConstant";
import { CT_ScreenEvntDtls } from "../../Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import cleverTap, { triggerCleverTapEvent } from "../../../utils/CleverTap";
import TriggerGTAEvent from "../../../utils/GTA";
import { MuiOtpInput } from "mui-one-time-password-input";
import { API_STATUS_CODE } from "../../../utils/ApiEndpoints";
import CustomThreeDotsLoader from "../../../components/CustomThreeDotsLoader/CustomThreeDotsLoader";
import { useReadOTP } from "./ReadOtp";
import { AuthGuard } from "../../../routes/Guards/AuthGuard";
import validateOtpByPassResponse from "../MobileNumberEntry/ValidateOtpByPassResponse.json";
import useWindowSize from "../../../hooks/useWindowSize";
import { isEmpty } from "lodash";

declare const window: any;

type ChildComponentProps = {
  onMaximumAttempt: () => void;
  headerText: string;
};

const OtpEntry: React.FC<ChildComponentProps> = ({
  headerText,
  onMaximumAttempt,
}) => {
  const masterDetails = useAppSelector(
    (state) => state.GeneralAppElementsSlice.masterData?.masterDetail
  );
  const validateOtpByPassForMobiles: string[] =
    masterDetails?.generateOtpByPassForMobile?.map((m) => m.masterValue) || [
      "9930993328",
    ];
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const secondaryChannelSlice = useAppSelector(
    (state) => state.SecondaryChannelSlice
  );
  const wrongOtpCountAllowed = parseInt(
    masterDetails?.wrong_otp_count_allowed?.find(
      (item) => item.masterKey === "limit"
    )?.masterValue || "3"
  );
  const retryCount = parseInt(
    masterDetails?.retry_count?.find(
      (item) => item.masterKey === "otpBypassValue"
    )?.masterValue || "3"
  );
  const { width } = useWindowSize();
  const [otpVerifyAttemptLeft, setOtpVerifyAttemptLeft] =
    useState<number>(wrongOtpCountAllowed);
  const [reSendOtpAttemptLeft, setReSendOtpAttemptLeft] =
    useState<number>(retryCount);
  const [count, setCount] = useState<number>(60);
  const [validateOtpApi] = useLazyValidateOtpQuery();
  const [generateOtpApi] = useLazyGenerateOtpQuery();
  const isTimerOn = useRef(true);
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState<string>("");
  const [helperTextOtp, setHelperTextOtp] = useState<string>("");
  const appDispatch = useAppDispatch();
  const loginSlice = useAppSelector((state) => state.LoginSlice);
  const mobileNumber = loginSlice.mobilenumber || "";

  let customerAndLobDetails =
    loginSlice.csAndLobDetails?.payload.customerAndLobDetails || [];
  let customerEmailFromLobDetails = getValidEmailFromCustomerAndLobDetails(
    customerAndLobDetails
  );

  const emailIdFromConsent = useAppSelector(
    (state) => state.CsAppSlice.emailId
  );
  const [authGuardEnabled, initAuthGuardChecks] = useState(false);
  const [isFocused, setIsFocused] = useState<{ [index: number]: boolean }>({}); // Track focus state
  const navigate = useNavigate();

  const otpByPassValue =
    masterDetails?.otpBypass?.find(
      (item) => item.masterKey === "otpBypassValue"
    )?.masterValue || "";
  const isOtpBypassEnable =
    masterDetails?.otpBypass?.find((item) => item.masterKey === "otpBypassFlag")
      ?.masterValue || "";
  const [mPinCheckApi] = useLazyMPinExistQuery();
  const dispatch = useAppDispatch();
  function getMinutesBetweenDates(startDate: Date, endDate: Date) {
    const diff = endDate.getTime() - startDate.getTime();

    return diff / 60000;
  }
  useReadOTP(setOtp);

  useEffect(() => {
    triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
      ScreenName: CT_ScreenEvntDtls.R_GAE.gaLoginMobNumOtpVer.screenName,
      ScreenType: SCREEN_TYPE.LoginScreenType,
    });

    // if ("OTPCredential" in window) {
    //   window.addEventListener('DOMContentLoaded', (e) => {
    //   const ac = new AbortController();
    //   navigator.credentials
    //     .get({
    //       otp: { transport: ["sms"] },
    //       signal: ac.signal,
    //     } as any) // Use 'any' if you want to bypass type checks temporarily
    //     .then((otp: any) => {
    //      console.log(otp);
    //      // setOtp(otp.code);
    //       ac.abort();
    //     })
    //     .catch((err) => {
    //       console.log("OTP error" + err);
    //     });
    //   });
    // }
  }, []);

  useEffect(() => {
    if (otpVerifyAttemptLeft > 0) {
      return;
    }
    if (
      CsLocalStorageUtils.get("OTP_BLOCKED_TIME")?.length > 0 &&
      getMinutesBetweenDates(
        new Date(CsLocalStorageUtils.get("OTP_BLOCKED_TIME")),
        new Date()
      ) < 30
    ) {
      setReSendOtpAttemptLeft(0);
      setOtpVerifyAttemptLeft(0);
    } else {
      CsLocalStorageUtils.clear("OTP_BLOCKED_TIME");
    }
  }, [otpVerifyAttemptLeft]);

  useEffect(() => {
    startTimer();
  }, []);

  const startTimer = useCallback(() => {
    isTimerOn.current = true;
    const intervalId = setInterval(() => {
      setCount((prevCount) => {
        const newCount = prevCount - 1;
        if (newCount <= 0) {
          clearInterval(intervalId);
          isTimerOn.current = false;
          return 60;
        }
        return newCount;
      });
    }, 1000);
  }, []);
  const handleChange = (e: any) => {
    setOtp(e.target.value);
  };
  const handleOtpChange = (value: string) => {
    // const { value } = event.target;
    // setHelperTextOtp("");
    // if (/^\d{0,6}$/.test(value)) {
    //   setOtp(event.target.value);
    // }
    setOtp(value);
    setHelperTextOtp("");

    // If the OTP length is 6, focus out of the input and focus on the submit button
    if (value.length === 6) {
      // Remove focus from the OTP input box
      const activeElement = document.activeElement;
      if (
        activeElement &&
        (activeElement instanceof HTMLInputElement ||
          activeElement instanceof HTMLTextAreaElement)
      ) {
        activeElement.blur(); // This will remove focus from the current input field
      }

      // Use setTimeout to ensure blur happens before focusing on the button
      setTimeout(() => {
        const submitButton = document.getElementById("submitButton");
        if (submitButton) {
          submitButton.focus(); // Set focus to the submit button
        }
      }, 0); // You can adjust the timeout if necessary (0 ms will give it just enough time)
    }
  };

  const handleFocus = (index: number) => {
    setIsFocused((prev) => {
      return { ...prev, [index]: true };
    }); // Set focus state to true when input is focused
  };

  const handleBlur = (index: number) => {
    setTimeout(() => {
      setIsFocused((prev) => {
        return { ...prev, [index]: false };
      }); // Set focus state to false when input loses focus
    }, 500);
  };

  const gotoNextStep = (status: boolean) => {
    if (!status) {
      return;
    }
    if (headerText === "OTP Verification") {
      manageLoading(false);
      navigate("/set-mpin", { replace: true, state: { type: "forgetMpin" } });
      appDispatch(updateScreenTag(LoginScreenValues.setupMPN));
    } else if (csAppSlice.channel === E_ChannelOptions.SECONDARY_CHANNEL) {
      navigate(secondaryChannelSlice.constructedAppUrl, {
        state: secondaryChannelSlice.dynamicState,
        replace: true,
      });
    } else {
      navigate("/", { replace: true });
    }
  };

  const handleGotoAbcdApp = useCallback(() => {
    // if (getMobileOperatingSystem() === "iOS") {
    //   windowOpen(ABCD_APPSTORE_URL);
    // } else {
    //   windowOpen(ABCD_PLAYSTORE_URL);
    // }
    dispatch(updateScreenTag(LoginScreenValues.enterMobileScreen));
    navigate("/login");
  }, []);

  const handleByPassOtp = () => {
    if (otp === otpByPassValue) {
      onOtpMatched("");
    } else {
      onOtpMatchFailed();
    }
  };

  const onOtpMatched = (res: any) => {
    let onUserLoginCleverTapData = { ...onUserLoginCleverTapStatic };
    onUserLoginCleverTapData["Identity"] = "+91" + mobileNumber;
    onUserLoginCleverTapData["Phone"] = "+91" + mobileNumber;
    onUserLoginCleverTapData["MSG-sms"] = true;
    onUserLoginCleverTapData["MSG-whatsapp"] = true;
    onUserLoginCleverTapData["MSG-push"] = !isEmpty(
      csAppSlice.NativeDeviceInfo?.deviceName
    );
    if (!onUserLoginCleverTapData.DOB) {
      delete onUserLoginCleverTapData.DOB;
    }
    if (isEmpty(csAppSlice.NativeDeviceInfo?.deviceName)) {
      cleverTap.onUserLogin.push({ Site: onUserLoginCleverTapData });
    }
    triggerCleverTapEvent("onUserLogin", {
      ScreenType: SCREEN_TYPE.generalAppType,
      ScreenName: "Servicing Login Mobile Number OTP Verification Screen",
      isPrevPageNameRequired: true,
      ...onUserLoginCleverTapData,
      MSG_email: onUserLoginCleverTapData["MSG-email"],
      MSG_push: onUserLoginCleverTapData["MSG-push"],
      MSG_sms: onUserLoginCleverTapData["MSG-sms"],
      MSG_whatsapp: onUserLoginCleverTapData["MSG-whatsapp"],
    });
    CsSessionStorageUtils.set("LOGGED_IN_TIME", new Date().toISOString());
    appDispatch(
      updateLoginData({
        key: "isOtpVerificationDone",
        value: true,
      })
    );
    appDispatch(updateLoginData({ key: "isUserLoggedIn", value: true }));
    if (res) {
      appDispatch(
        updateLoginData({ key: "displayRateUs", value: res.displayRateUs })
      );
    }
    initAuthGuardChecks(true);
    // gotoNextStep();
  };

  const onOtpMatchFailed = () => {
    appDispatch(
      updateLoginData({
        key: "isOtpVerificationDone",
        value: false,
      })
    );
    if (otpVerifyAttemptLeft > 0) {
      setHelperTextOtp(`Incorrect OTP entered. Please retry`);
      setOtp("");
      setOtpVerifyAttemptLeft((prevCount) => prevCount - 1);
    } else {
      onMaximumAttempt();
    }
  };

  const handleActualOtpSubmit = async () => {
    try {
      triggerCleverTapEvent("serv_login_mob_no_otp_verify_click", {
        ScreenType: SCREEN_TYPE.generalAppType,
        ScreenName: "Servicing Login Mobile Number OTP Verification Screen",
        isPrevPageNameRequired: true,
        ctaText: "continue",
      });
      TriggerGTAEvent("serv_login_mob_no_otp_verify_click", {
        screen_type: GTAScreenType.LoginScreenType,
        screen_name: "servicing_login_mobile_number_otp_verification_screen",
        CTA_text: "continue",
      });
      manageLoading(true);
      const res = validateOtpByPassForMobiles.includes(mobileNumber)
        ? validateOtpByPassResponse
        : await validateOtpApi({
            mobileNo: mobileNumber,
            otp: otp,
          });
      if (res.data?.code === 1 && res.data.payload.mobileNo === mobileNumber) {
        onOtpMatched(res.data?.payload);
      } else {
        manageLoading(false);
        onOtpMatchFailed();
      }
    } catch (err) {
      const e = err as Error;
      manageLoading(false);
      appDispatch(
        setError({
          error: e,
          message: e.message,
        })
      );
    }
  };

  const handleOtpSubmitButton = () => {
    // if (isOtpBypassEnable === "true") {
    //   handleByPassOtp();
    // } else {
    handleActualOtpSubmit();
    //}
  };

  const manageLoading = useCallback((showLoading: boolean = false) => {
    // appDispatch(updateLoadingState(showLoading));
    setLoading(showLoading);
  }, []);

  const sendOtp = async () => {
    setOtp("");
    try {
      const requestParams: T_GenerateOtpPay = {
        mobileNo: mobileNumber,
        otp: "",
        functionality: functionalityCodeForGenerateOtpApi,
      };
      // Add emailId to requestParams only if it's not empty from fetchConsent api response
      if (emailIdFromConsent && emailIdFromConsent.trim() !== "") {
        requestParams.emailId = emailIdFromConsent;
      }
      if (!isEmpty(customerEmailFromLobDetails)) {
        requestParams.emailId = customerEmailFromLobDetails;
      }
      manageLoading(true);
      const r = await generateOtpApi(requestParams);
      manageLoading(false);
      if (r.isError && r.error) {
        const e =
          (r.error as T_ApiResponse<any>) || Error("Something went wrong");
        appDispatch(
          setError({
            error: e,
            message: otpScreenErrorMsg,
          })
        );
        if (e?.code === API_STATUS_CODE.BUSINESS_ERROR) {
          setReSendOtpAttemptLeft(0);
          setOtpVerifyAttemptLeft(0);
        }
      } else if (!r.error && r.data?.code === API_STATUS_CODE.SUCCESS) {
        setReSendOtpAttemptLeft((prev) => prev - 1);
        startTimer();
      } else {
        appDispatch(
          setError({
            error: r.data,
            message: r.data?.message,
          })
        );
      }
    } catch (err) {
      const e = err as Error;
      appDispatch(setError({ error: e, message: e.message }));
    }
  };

  let finalVerifyAttemptMessage: string = "";
  if (otpVerifyAttemptLeft <= 0 || reSendOtpAttemptLeft <= 0) {
    finalVerifyAttemptMessage = otpScreenErrorMsg;
    // CsLocalStorageUtils.set("OTP_BLOCKED_TIME",dayjs().toString());
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior
      handleOtpSubmitButton(); // Call your confirm function
    }
    if (e.key === "Delete") {
      if (otp.length > 0) {
        // Handle deletion: you can remove the last character or handle it as needed
        setOtp((prevOtp) => prevOtp.slice(0, -1));
        // Focus management after deleting: focus on the previous field when deleting
        const focusedIndex = otp.length - 1;
        if (focusedIndex > 0) {
          // Focus on the previous input (if exists)
          const inputs = document.querySelectorAll("input.otp-input");
          if (inputs[focusedIndex - 1]) {
            (inputs[focusedIndex - 1] as HTMLInputElement).focus();
          }
        }
      }
    }
  };

  return (
    <Box
      className="enter-otp-wrapper"
      minWidth={"12.5rem"}
      width={"100%"}
      maxWidth={"23.9375rem"}
    >
      <CustomPopup
        open={otpVerifyAttemptLeft <= 0 || reSendOtpAttemptLeft <= 0}
        handleOpen={defaultEmptyFun}
      >
        <Box padding="1.5rem 1rem">
          <Box
            display="flex"
            justifyContent="center"
            flexDirection={"column"}
            textAlign={"center"}
            alignItems={"center"}
          >
            <CommonGifAnimation
              animationData={ExclamationMarkGif as T_AnimationData}
            />
            <Typography
              marginTop={"2rem"}
              variant="h3"
              color={Colors.textblack}
            >
              {finalVerifyAttemptMessage}
            </Typography>
            <Button
              sx={{ width: "100%", marginTop: "2rem" }}
              type="button"
              variant="contained"
              onClick={handleGotoAbcdApp}
            >
              Go to ABC Login Page
            </Button>
          </Box>
        </Box>
      </CustomPopup>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        marginTop="1rem"
      >
        <img src={otpVerificationImage} alt="otp" />
        <Typography textAlign="center" marginTop="1.5rem" variant="h2">
          OTP Verification
        </Typography>
        <Typography
          textAlign="center"
          marginTop=".25rem"
          variant="subtitle2"
          color={Colors.textGray}
          width="75%"
        >
          Enter the 6 digit code sent to{" "}
          <span style={{ color: Colors.red, fontWeight: 500 }}>
            {mobileNumber}
          </span>
          {!isEmpty(customerEmailFromLobDetails) &&
            " and your registered email Id"}
        </Typography>
      </Box>

      <Box width={"90%"} marginX={"auto"}>
        <input
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          style={{ display: "none" }}
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
        />

        <MuiOtpInput
          className={`otp-input ${helperTextOtp.length > 0 ? "error" : ""}`}
          length={6}
          value={otp}
          onChange={handleOtpChange}
          onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
            handleKeyDown(e)
          }
          validateChar={(char) => /^[0-9]$/.test(char)}
          TextFieldsProps={(index) => {
            return {
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
                onFocus: () => {
                  handleFocus(index);
                },
                onBlur: () => {
                  handleBlur(index);
                },
              },
            };
          }}
        />
        <Box marginLeft={width < 420 ? "0rem" : "1.4rem"}>
          {helperTextOtp && (
            <Box display="flex" gap={".25rem"} alignItems="center">
              <img src={AlertRhombus} />
              <Typography marginY={"0.5rem"} color={Colors.red} variant="h6">
                {helperTextOtp}
              </Typography>
            </Box>
          )}
          {isTimerOn.current ? (
            <Typography
              sx={{
                fontWeight: "500",
                fontSize: ".875rem",
                lineHeight: "1.05rem",
                color: "#9C9C9C",
                height: ".875rem",
              }}
            >
              {`Resend OTP in 00:${count.toString().padStart(2, "0")}s`}
            </Typography>
          ) : !isTimerOn.current && reSendOtpAttemptLeft > 0 ? (
            <Button
              id="resendOtp"
              variant="text"
              color="primary"
              onClick={() => {
                if (otpVerifyAttemptLeft > 0) {
                  sendOtp();
                }
              }}
            >
              {"Resend OTP"}
            </Button>
          ) : null}
        </Box>
      </Box>
      <Box display="flex" justifyContent="center" marginTop="1.25rem">
        {loading ? (
          <>
            <CustomThreeDotsLoader isOverLayRequired={false} withText={true} />
            {authGuardEnabled && (
              <AuthGuard
                initFlag={authGuardEnabled}
                showCustomLoading={true}
                resultCallback={gotoNextStep}
                fallbackUi={<></>}
              />
            )}
          </>
        ) : (
          <Button
            id="submitButton"
            variant="contained"
            onClick={handleOtpSubmitButton}
            disabled={otpVerifyAttemptLeft <= 0 || otp.length < 6}
            sx={{
              width: "100%",
              height: "3rem",
              borderRadius: "1.25rem",
            }}
            disableFocusRipple
            disableRipple
          >
            {"Submit"}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default OtpEntry;
